export default {
  state: {
    isDev: process.env.NODE_ENV == 'development',
    layoutAlive: true
  },
  getters: {
    isDev: state => state.isDev,
    layoutAlive: state => state.layoutAlive
  }
}


// WEBPACK FOOTER //
// ./src/store/app.js